import {
  getRequiredFields,
  removeEmptyFields,
  setEmptyFieldsToNull,
} from "@/lib/utils";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  CURRICULUM_NOTES,
  DESIGNATION,
  EMAIL,
  INCLUDES_3D_PRINTER,
  INCLUDES_CHAIRS,
  INCLUDES_ELECTRICAL,
  INCLUDES_PAINTING,
  INCLUDES_PODIUM_MIC,
  INCLUDES_STORAGE_CABINETS,
  INCLUDES_TABLETS,
  INCLUDES_TEACHERS_TABLE,
  INCLUDES_TV,
  INFRASTRUCTURE_NOTES,
  NAME,
  OTHER_NOTES,
  PHONE,
  POC_DETAILS,
} from "./consts";
import { formValues, schema } from "./validations";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import {
  useCreateSchoolInventoryDetailMutation,
  useCreateSchoolLabPocMutation,
  useGetSchoolInventoryDetailBySchoolIdQuery,
  useGetSchoolLabPocBySchoolIdQuery,
} from "@/services";

const useCrmMgmtInfo = () => {
  const { action } = useParams();
  const [currentTab, setCurrentTab] = useState<string>("1");

  const onTabChange = (value: string) => {
    setCurrentTab(value);
  };

  const onNextClick = () => {
    setCurrentTab((Number(currentTab) + 1).toString());
  };

  return {
    currentTab,
    action,
    onTabChange,
    onNextClick,
  };
};

export default useCrmMgmtInfo;
